import { Quaternion, Vector3 } from '@technology/web3d';
import { AlignmentNavigationCapability } from '@trimble/web3d-capabilities';
import { SyncFn } from './sync-coordinator';
import { getActiveNavCap, updateFrustum } from './sync-source-helpers';
import {
  getStationSyncPosition,
  isStationOrientationMeaningful,
} from './source-positions';

/**
 * Syncs from a station/image source pane to an alignment target pane.
 * Reads the station position from source and navigates the alignment tool
 * in the target. Propagates source quaternion when source orientation is
 * meaningful (i.e. not Planar) and target is not in cross-section mode.
 */
export const syncStationToAlignment: SyncFn = async (source, target) => {
  const syncPosition = getStationSyncPosition(source);
  if (!syncPosition) return;

  const sourceViewer = source.viewerWrapper()?.viewer;
  const targetViewer = target.viewerWrapper()?.viewer;
  if (!sourceViewer || !targetViewer) return;

  const targetCap = getActiveNavCap(target);
  if (!(targetCap instanceof AlignmentNavigationCapability)) return;

  const targetPosition = new Vector3(
    syncPosition.x,
    syncPosition.y,
    syncPosition.z
  );

  const propagateOrientation =
    isStationOrientationMeaningful(source) && !targetCap.crossSectionEnabled();

  if (propagateOrientation) {
    await targetCap.navigateToWorldPosition(
      targetPosition,
      new Quaternion(...sourceViewer.camera.quaternion.toArray())
    );
  } else {
    await targetCap.navigateToWorldPosition(targetPosition);
  }

  updateFrustum(
    target,
    syncPosition,
    propagateOrientation ? sourceViewer.camera.quaternion.toArray() : null,
    null
  );
};
